/**
 * Defines the roles a user can have within the system.
 */
export enum UserRoleTypes {
  SUPER_ADMIN = 'super-admin',
  ADMIN = 'admin',
  MANAGER = 'manager',
  CUSTOMER = 'customer'
}

/**
 * Defines the type of customer account.
 */
export enum UserCustomerType {
  COMPANY = 'company',
  INDIVIDUAL = 'individual'
}

/**
 * Defines the shape of a user role object from the API.
 */
export interface UserRole {
  id: number;
  value: UserRoleTypes;
}

/**
 * Defines the shape of the user object returned by the API.
 */
export interface UserResponse {
  id: number;
  name: string;
  email: string;
  readonly type: string;
  readonly id_number?: string;
  readonly tax_id?: string;
  roles?: string[];
  permissions?: string[];
}

/**
 * Defines the payload for the user registration endpoint.
 */
export interface UserRegisterPayload {
  name: string;
  email: string;
  password: string;
  cart_token?: string;
  type?: string;
  id_number?: string;
  tax_id?: string;
}

/**
 * Defines the payload for the user login endpoint.
 */
export interface UserLoginPayload {
  email: string;
  password: string;
  cart_token?: string;
}
